export default "__VITE_ASSET__Ccs_OJXT__"